import { PretensionsRepository } from '../repositories/pretensions.repository'
import {
    PretensionsAttachDocumentResponseT,
    PretensionsDownloadPretensionResponseT,
    PretensionsDownloadDocumentResponseT,
    PretensionsGetPretensionResponseT,
    PretensionsGetListResponseT,
    PretensionsGetParamsT,
    PretensionsGetStatusesResponseT,
    PretensionsGetTypesResponseT,
    PretensionsShowPretensionResponseT,
    PretensionsShowDocumentResponseT,
    CompensationsGetParamsT,
    PretensionChangeStatusT,
    PretensionShortT,
    QualityControlCommentT,
    PretensionsDownloadPretensionPayloadT,
    SBCommentT,
    GetGuiltySidesResponse,
} from '../types/pretensions.types'

const pretensionsRepository = new PretensionsRepository()

export class PretensionsService {
    async deletePretension(pretension_id: number): Promise<void> {
        await pretensionsRepository.deletePretension(pretension_id)
    }

    async deleteFile(id: number): Promise<void> {
        await pretensionsRepository.deleteFile(id)
    }

    async getList(params: PretensionsGetParamsT): Promise<PretensionsGetListResponseT> {
        const response = await pretensionsRepository.getList(params)
        return response.data
    }

    async exportExcel(
        payload: PretensionsDownloadPretensionPayloadT
    ): Promise<PretensionsDownloadPretensionResponseT> {
        const response = await pretensionsRepository.exportExcel(payload)
        return response.data
    }

    async getPretension(pretension_id: number): Promise<PretensionsGetPretensionResponseT> {
        const response = await pretensionsRepository.getPretension(pretension_id)
        return response.data
    }

    async createPretension(form_data: FormData): Promise<void> {
        await pretensionsRepository.createPretension(form_data)
    }

    async saveAgreedData(params: CompensationsGetParamsT): Promise<void> {
        await pretensionsRepository.saveAgreedData(params)
    }

    async changeStatus(status_params: PretensionChangeStatusT): Promise<void> {
        await pretensionsRepository.changeStatus(status_params)
    }

    async saveLegalDepartmentComment(id: number, payload: FormData): Promise<void> {
        await pretensionsRepository.saveLegalDepartmentComment(id, payload)
    }

    async updatePretensionInfo(params: PretensionShortT): Promise<void> {
        await pretensionsRepository.updatePretensionInfo(params)
    }

    async addQualityControlComment(comment_params: QualityControlCommentT): Promise<void> {
        await pretensionsRepository.addQualityControlComment(comment_params)
    }

    async addSBComment(comment_params: SBCommentT): Promise<void> {
        await pretensionsRepository.addSBComment(comment_params)
    }

    async addEmployeeFiles(files_params: FormData): Promise<void> {
        await pretensionsRepository.addEmployeeFiles(files_params)
    }

    async attachDocument(params: FormData): Promise<PretensionsAttachDocumentResponseT> {
        const response = await pretensionsRepository.attachDocument(params)
        return response.data
    }

    async downloadPretension(
        pretension_id: number
    ): Promise<PretensionsDownloadPretensionResponseT> {
        const response = await pretensionsRepository.downloadPretension(pretension_id)
        return response.data
    }

    async showPretension(pretension_id: number): Promise<PretensionsShowPretensionResponseT> {
        const response = await pretensionsRepository.showPretension(pretension_id)
        return response.data
    }

    async downloadDocument(document_id: number): Promise<PretensionsDownloadDocumentResponseT> {
        const response = await pretensionsRepository.downloadDocument(document_id)
        return response.data
    }

    async showDocument(document_id: number): Promise<PretensionsShowDocumentResponseT> {
        const response = await pretensionsRepository.showDocument(document_id)
        return response.data
    }

    async getTypes(page: number): Promise<PretensionsGetTypesResponseT> {
        const response = await pretensionsRepository.getTypes(page)
        return response.data
    }

    async getGuiltySides(): Promise<GetGuiltySidesResponse> {
        const response = await pretensionsRepository.getGuiltySides()
        return response.data
    }

    async getStatuses(page: number): Promise<PretensionsGetStatusesResponseT> {
        const response = await pretensionsRepository.getStatuses(page)
        return response.data
    }

    async getCompensations(page: number): Promise<PretensionsGetTypesResponseT> {
        const response = await pretensionsRepository.getCompensations(page)
        return response.data
    }

    async getCulprits(page: number): Promise<PretensionsGetTypesResponseT> {
        const response = await pretensionsRepository.getCulprits(page)
        return response.data
    }
}
